(ns motorsaif.web.admin.users
  (:require
   [motorsaif.web.components :as c]
   [motorsaif.web.components.tabular :as tabular]
   [motorsaif.frontend-routes :as routes]
   [re-frame.core :as rf :refer [subscribe]]
   [reagent.core :as r]
   [motorsaif.time :as time]))

(defn accordion [vis hidden]
  (let [*shown (r/atom false)]
    (fn []
      [:div.accordion
       [:div.vis
        {:on-click #(swap! *shown not)}
        vis]
       (when @*shown
         [:div.hidden
          hidden])])))

(defn users []
  (let [users @(subscribe [:admin-data :users])
        data (map (fn [{id :db/id
                        webpush :webpush
                        :user/keys [handle last-seen created email status] :as ent}]
                    (let [status (:db/ident status)
                          created (or (time/default-ago-str-date created) "N/A")
                          last-seen (or (time/default-ago-str-date last-seen) "N/A")
                          visible [{:title "Created"
                                    :val (str created)}
                                   {:title "Last Seen"
                                    :val (str last-seen)}
                                   {:title "Handle"
                                    :val handle}
                                   {:title "Email"
                                    :val email}
                                   {:title "Status"
                                    :val status}
                                   {:title "Webpush"
                                    :val (if (seq webpush)
                                           (count webpush) " - ")}]

                          hidden [(fn []
                                    (if (seq webpush)
                                      [:span.val
                                       {:style {:font-size "10px"}}
                                       (into [:ul]
                                             (map (fn [itm]
                                                    [:li itm])
                                                  webpush))] " - "))
                                  (fn [] [:a.btn.primary.small
                                          {:href
                                           (routes/path-for :admin-entity {:table :users
                                                                           :id id})}
                                          "Edit"])]]
                      {:hidden hidden
                       :visible visible}))
                  (reverse (sort-by :user/created users)))]
    [:div.content.container
     [tabular/table data]
     #_(str data)]))

(defn root []
  [users])
